module.exports = __webpack_public_path__ + "img/mczt-wx1.9989e606.png";